import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "32",
      height: "32",
      fill: "#fff",
      rx: "8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59ad3b",
      d: "M16 4A10.7 10.7 0 0 0 5.284 14.712c0 .272.25.476.516.421l2.142-.427c.2-.04.345-.216.345-.42 0-4.016 3.697-7.714 7.713-7.714 4.015 0 7.717 3.698 7.717 7.713-.001.204.142.38.341.421l2.145.427a.429.429 0 0 0 .513-.42A10.7 10.7 0 0 0 16 4Zm-.006 10.495a.429.429 0 0 0-.421.432v10.286c0 .572.858.572.858 0V14.927a.429.429 0 0 0-.437-.432Zm-7.28 1.075c-1.18 0-2.142.965-2.142 2.145v5.571c0 1.18.962 2.142 2.142 2.142a2.15 2.15 0 0 0 2.145-2.142v-5.571c0-1.18-.966-2.145-2.145-2.145Zm14.572 0c-1.18 0-2.142.965-2.142 2.145v5.571c0 1.18.963 2.142 2.142 2.142 1.18 0 2.142-.962 2.142-2.142v-5.571c0-1.18-.962-2.145-2.142-2.145Zm-9.428 1.072v6.856c-.013.584.87.584.857 0v-6.856a.426.426 0 0 0-.455-.434.424.424 0 0 0-.402.434Zm3.43 0v6.856c-.056.623.91.623.854 0v-6.856a.425.425 0 0 0-.456-.434.423.423 0 0 0-.398.434ZM5.297 17.715C4.578 17.695 4 18.295 4 19v2.999c0 .705.58 1.287 1.284 1.287h.43v-5.571h-.417Zm20.989 0v5.571h.43C27.42 23.286 28 22.704 28 22v-3a1.29 1.29 0 0 0-1.284-1.284h-.43Zm-6.863.206a.428.428 0 0 0-.424.437v3.43c0 .571.858.571.858 0v-3.43a.429.429 0 0 0-.434-.437Zm-6.859.857a.43.43 0 0 0-.42.437v3.43c0 .571.857.571.857 0v-3.43a.429.429 0 0 0-.437-.437Z"
    }, null, -1)
  ])))
}
export default { render: render }